export default "__VITE_PUBLIC_ASSET__8d9ccd61__"